import { SelectOption } from '@mui/base';
import cx from 'classnames';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { components, ControlProps } from 'react-select';
import { Form } from './Form';
import css from './HourPicker.module.scss';

const HOUR_OPTIONS = [
  { label: '12:00', value: 0 },
  { label: '1:00', value: 1 },
  { label: '2:00', value: 2 },
  { label: '3:00', value: 3 },
  { label: '4:00', value: 4 },
  { label: '5:00', value: 5 },
  { label: '6:00', value: 6 },
  { label: '7:00', value: 7 },
  { label: '8:00', value: 8 },
  { label: '9:00', value: 9 },
  { label: '10:00', value: 10 },
  { label: '11:00', value: 11 },
];

interface IHourPickerProps {
  className?: string;
  errorMessage?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  onChange: (value: number) => void;
  placeholder?: string;
  value: number;
}

export const HourPicker = ({
  className,
  errorMessage,
  isDisabled = false,
  isInvalid = false,
  onChange,
  placeholder = 'Select...',
  value,
}: IHourPickerProps) => {
  const [isAm, setAm] = useState<boolean>(value < 12);
  const [hour, setHour] = useState<number>(
    _.isNil(value) ? undefined : value % 12
  );

  const handleChange = (value: number) => {
    setHour(value);
    onChange(isAm ? value : value + 12);
  };

  useEffect(() => {
    setHour(_.isNil(value) ? undefined : value % 12);
    setAm(value < 12);
  }, [value]);

  return (
    <Form.Select
      className={cx(css.select, className, {
        [css.disabled]: isDisabled,
      })}
      components={{
        Control: ({ children, ...props }: ControlProps) => (
          <components.Control {...props}>
            {children}
            <input
              className={css.amPmButton}
              onClick={(ev) => {
                setAm(!isAm);
                onChange(!isAm ? hour : hour + 12);
                ev.preventDefault();
                ev.stopPropagation();
              }}
              type="submit"
              value={isAm ? 'AM' : 'PM'}
            />
          </components.Control>
        ),
      }}
      errorMessage={errorMessage}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      onChange={({ value }: SelectOption<number>) => {
        handleChange(value);
      }}
      options={HOUR_OPTIONS}
      placeholder={placeholder}
      value={_.find(HOUR_OPTIONS, { value: hour })}
    />
  );
};
